import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const getTransferOrderRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/transfer-orders/:id',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/transfer-orders/:id' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getTransferOrderResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 1,
        'number': 'TO-00001',
        'status': 'Issued',
        'type': 'Ship',
        'fromLocationGroup': {
            'id': 1,
            'name': 'Main Warehouse'
        },
        'toLocationGroup': {
            'id': 2,
            'name': 'East Warehouse'
        },
        'carrier': {
            'id': 5,
            'name': 'USPS'
        },
        'shipFromAddress': {
            'name': 'Main Warehouse',
            'street': '100 Main St',
            'city': 'Salt Lake City',
            'state': 'UT',
            'postalCode': '84101',
            'country': 'UNITED STATES'
        },
        'shipToAddress': {
            'name': 'East Warehouse',
            'street': '200 East Blvd',
            'city': 'Denver',
            'state': 'CO',
            'postalCode': '80201',
            'country': 'UNITED STATES'
        },
        'note': '',
        'ownerIsFrom': true,
        'revisionNumber': 1,
        'lastModified': {
            'username': 'admin',
            'dateLastModified': '2024-03-01T10:00:00.000-0700'
        },
        'dateCreated': '2024-03-01T08:00:00.000-0700',
        'dateIssued': '2024-03-01T10:00:00.000-0700',
        'dateScheduled': '2024-03-05T00:00:00.000-0700',
        'toItems': [
            {
                'id': 101,
                'part': {
                    'id': 28,
                    'name': 'B201',
                    'description': 'Premium Brake Cables'
                },
                'type': {
                    'id': 10,
                    'name': 'Send'
                },
                'status': 'Entered',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'lineNumber': 1,
                'note': '',
                'quantity': '10',
                'quantityFulfilled': '1',
                'quantityPicked': '1',
                'unitCost': '1',
                'dateScheduled': '2024-03-05T00:00:00.000-0700'
            }
        ],
        'customFields': [
            {
                'id': 19,
                'name': 'Custom',
                'value': 'My Custom Field',
                'type': 'Text'
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'get-transfer-order',
    title: 'Get a transfer order',
    description: 'Retrieves the details of an existing transfer order. You only need to provide the unique transfer order ID.',
    endpoint: {
        verb: 'GET',
        path: '/transfer-orders/:id',
        tooltip: 'Get a transfer order',
    },
    attributes: [],
    requestObject: getTransferOrderRequest,
    responseObject: getTransferOrderResponse,
};

export default data;
